import React, { useMemo } from 'react'
import { useNavigate } from 'react-router'
import { Badge, Stack, SimpleTabs } from '@/components/lib'

import useStore from '../../../store'
import useTitle from '../../../hooks/useTitle'

import utils from '../../../utils/utils'
import List from './List'
import Groups from './Groups'
import ParticipantResources from './Resources'

export default function Participants () {
  const navigate = useNavigate()
  const { trial, groups, team, user } = useStore()
  useTitle('Participants', trial)

  const base = `/trials/${trial?._id}/participants`

  const groupCount = useMemo(() => (groups?.length || 0), [groups])
  const participantCount = trial?.participantCount || 0
  const participantResourcesFeature = team && utils.hasFeature(team, 'participantResources') && utils.canReadTrial(user, trial)
  const participantsTabTitle = (
    <Stack direction='row' alignItems='center' gap={2}>
      <span>Participants</span>
      <Badge size='sm' borderRadius='full' variant='subtle' colorPalette='blue'>{participantCount}</Badge>
    </Stack>
  )

  const groupsTabTitle = (
    <Stack direction='row' alignItems='center' gap={2}>
      <span>Participant groups</span>
      <Badge size='sm' borderRadius='full' variant='subtle' colorPalette='blue'>{groupCount}</Badge>
    </Stack>
  )

  return (
    <SimpleTabs
      tabs={[
        { key: 'participants', title: participantsTabTitle, plainTitle: 'Participants', to: base, content: <List /> },
        { key: 'groups', title: groupsTabTitle, plainTitle: 'Groups', to: `${base}/groups`, content: <Groups onViewParticipants={() => navigate(base)} /> },
        participantResourcesFeature && { key: 'resources', title: 'Participant resources', plainTitle: 'Resources', to: `${base}/resources`, content: <ParticipantResources /> }
      ]}
    />
  )
}
